import FundWeightsForm from 'src/javascripts/components/forms/FundWeightsForm';

export default class FundWeightsNew {

  constructor() {}

  render() {

    // Call associated form js
    FundWeightsForm();

  }

}